import { VitalSignsKeys } from '@/components/patient/models/VitalSignsKeys'
import type { VitalSignItemDTO } from '@/generated'

const keysWithIntegerValues: VitalSignsKeys[] = [
  VitalSignsKeys.HEART_RATE,
  VitalSignsKeys.INV_S_BP,
  VitalSignsKeys.INV_D_BP,
  VitalSignsKeys.NON_INV_S_BP,
  VitalSignsKeys.NON_INV_D_BP
]

const keysWithDecimalValues: VitalSignsKeys[] = [
  VitalSignsKeys.RR,
  VitalSignsKeys.SPO2,
  VitalSignsKeys.TEMP
]

export const formatVitalSigns = (vitalSigns: VitalSignItemDTO[]) => {
  return vitalSigns.map((vitalSign) => {
    const key = vitalSign.typeKey

    if (keysWithIntegerValues.includes(key as VitalSignsKeys)) {
      return {
        ...vitalSign,
        numericValue: Math.round(vitalSign.numericValue)
      }
    }

    if (keysWithDecimalValues.includes(key as VitalSignsKeys)) {
      return {
        ...vitalSign,
        numericValue: Number(vitalSign.numericValue.toFixed(1))
      }
    }

    return {
      ...vitalSign
    }
  })
}
